export default __webpack_public_path__ + "static/media/img_misc_two.friends.hugging@2x.eb8eb3ee.png";